/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserResponseAttachment model module.
 * @module model/UserResponseAttachment
 * @version 1.0
 */
class UserResponseAttachment {
    /**
     * Constructs a new <code>UserResponseAttachment</code>.
     * @alias module:model/UserResponseAttachment
     */
    constructor() { 
        
        UserResponseAttachment.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserResponseAttachment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserResponseAttachment} obj Optional instance to populate.
     * @return {module:model/UserResponseAttachment} The populated <code>UserResponseAttachment</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserResponseAttachment();

            if (data.hasOwnProperty('uuid')) {
                obj['uuid'] = ApiClient.convertToType(data['uuid'], 'String');
            }
            if (data.hasOwnProperty('filename')) {
                obj['filename'] = ApiClient.convertToType(data['filename'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('size')) {
                obj['size'] = ApiClient.convertToType(data['size'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * Class UserResponseAttachment
 * @member {String} uuid
 */
UserResponseAttachment.prototype['uuid'] = undefined;

/**
 * Class UserResponseAttachment
 * @member {String} filename
 */
UserResponseAttachment.prototype['filename'] = undefined;

/**
 * Class UserResponseAttachment
 * @member {String} type
 */
UserResponseAttachment.prototype['type'] = undefined;

/**
 * Class UserResponseAttachment
 * @member {Number} size
 */
UserResponseAttachment.prototype['size'] = undefined;






export default UserResponseAttachment;

